import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Helper } from 'src/app/shared/utils/helper';
import { environment } from 'src/environments/environment';
import { InitRequestResponse, MyBusinessWalletDetails, WalletFormData } from '../components/finance/wallet/state/wallet.interface';
@Injectable({ providedIn: 'root' })

export class WalletService {
  readonly baseUrl: string = `${environment.baseUrl}`;
  constructor(private http: HttpClient) { }

  get_businessAccounts(): Observable<[{ text: string, value: string }]> {
    const params = new HttpParams()
    .set("selfInculded", "true")
    .set("useIsLastMile", "false");
    return this.http.get(`${this.baseUrl}/business/selectlist/allowed`, {params:params})
      .pipe(
        map((res: any) => res.result)
      );
  }

  get_wallet(businessid: Required<string>): Observable<MyBusinessWalletDetails> {
    return this.http.get<MyBusinessWalletDetails>(`${this.baseUrl}/wallet/business/${businessid}`)
      .pipe(
        map((res: any) => res.result)
      );
  }

  get_payAsGuestNow(data:Partial<WalletFormData>) {
    return this.http.post<InitRequestResponse>(`${this.baseUrl}/prestogateway/init`, data)
    .pipe(
      map((resp:any)=>resp.result)
    );
  }

  ca_confirmPaymentRequest(paymentRefNum:Required<string>, token) {
    const header = new HttpHeaders()
    .set("Authorization", `Bearer ${token}`);
    const data = { paymentRefNum:paymentRefNum };
    return this.http.put(`${this.baseUrl}/prestogateway/confirm/${paymentRefNum}`, data, {
      headers: header
    });
  }

  confirmPaymentRequest(paymentRefNum:Required<string>) {
    const data = { paymentRefNum:paymentRefNum };
    return this.http.put(`${this.baseUrl}/prestogateway/confirm/${paymentRefNum}`, data);
  }


  getListing(listParams) {
    const prm = this.setParams(listParams);
  return this.http.get(`${this.baseUrl}/prepaidentry/list/online`, { params: prm });
  }

  private setParams(param): HttpParams {
    const { Sort, SortDirection, BusinessId, DateFrom, DateTo, Page, Query } = param;
    let params = new HttpParams().set("Page", Page).set("Query", Query);
    if (Sort!=null&&SortDirection!=null) {
      params = params.set("Sort",Sort).set("SortDirection",SortDirection);
    }
    if (!Helper.isEmpty(BusinessId)) {
      params = params.set("BusinessId",BusinessId);
    }
    if (DateFrom!=null) {
      const d = Helper.getDateStr(DateFrom)
      params = params.set("DateFrom",d+"");
    }
    if (DateTo!=null) {
      const d = Helper.getDateStr(DateTo)
      params = params.set("DateTo",d+"");
    }
    return params;
  }


  loadAllowedBusiness():Observable<any>{
    const params = new HttpParams()
    // .set('businessType', 'internal')
    .set('useIsLastMile', "false")
    return this.http.get(`${this.baseUrl}/business/selectlist/allowed`, {params:params})
    .pipe(
      map((res:any)=>res.result)
    );
  }
}
